// custom functions
const FE = {
    MobileMenu: {
        init: function() {
            const burgerBtn = document.getElementById('burger-icon');
            const targetId = burgerBtn.getAttribute('aria-controls');
            const menuLayer = document.getElementById(targetId);
            const closeBtn = document.querySelector('.nav-main-layer-close');

            burgerBtn.addEventListener("click", function () {
                if ( menuLayer.classList.contains('active') ) {
                    FE.MobileMenu.close(burgerBtn, menuLayer);
                } else {
                    FE.MobileMenu.open(burgerBtn, menuLayer);
                }
            });

            closeBtn.addEventListener("click", function () {
                FE.MobileMenu.close(burgerBtn, menuLayer);
            });
        },
        open: function (burgerBtn, menuLayer) {
            burgerBtn.setAttribute('aria-expanded', 'true');
            menuLayer.classList.add('open');
        },
        close: function (burgerBtn, menuLayer) {
            burgerBtn.setAttribute('aria-expanded', 'false');
            menuLayer.classList.remove('open');
        }

    },

	location: window.location,

    Accordion: {
        init: function () {
            const accordions = document.querySelectorAll('.ce-text_image_accordion--item');
            accordions.forEach(function (accordion) {
                accordion.querySelector('button').addEventListener('click', FE.Accordion.handleAccordionClick);
            });
        },
        handleAccordionClick: function (e) {
            if (e.currentTarget.getAttribute('aria-expanded') === 'false') {
                e.currentTarget.setAttribute('aria-expanded', 'true');
                document.getElementById(e.currentTarget.getAttribute('aria-controls')).classList.add('open');
            } else {
                e.currentTarget.setAttribute('aria-expanded', 'false');
                document.getElementById(e.currentTarget.getAttribute('aria-controls')).classList.remove('open');
            }
        }
    },

    Lightbox: {
        init: function () {
            const parvus = new Parvus({
                captionsAttribute: 'alt'
            });
        }
    },

    HeroSlider: {
        init: function () {
            var sliderContainer = document.querySelector('.ce-hero_slider--slides');
            var slides = document.querySelectorAll('.ce-hero_slider--slides figure');
            //console.log(sliderContainer, slides);
            this.setupSliderMarkup(sliderContainer, slides, false, true);
        },
        setupSliderMarkup: function (sliderContainer, slides, controls=false, bullets=false) {
            var sliderEl = document.createElement('div');
            var sliderTrack = '<div class="glide__track" data-glide-el="track"></div>';
            var sliderControls ='<div class="glide__arrows" data-glide-el="controls"><button class="glide__arrow glide__arrow--left" data-glide-dir="<">prev</button><button class="glide__arrow glide__arrow--right" data-glide-dir=">">next</button></div>';
            var sliderBullets = '';


            var slidesCount = slides.length;
            for (var i=0; i < slidesCount; i++) {
                slides[i].classList.add('glide__slide');
                sliderBullets += '<button class="slider__bullet glide__bullet" data-glide-dir="=' + i + '"></button>';
            }

            sliderEl.classList.add('glide');
            sliderContainer.parentNode.insertBefore(sliderEl, sliderContainer);
            sliderContainer.classList.add('glide__slides');

            var sliderInnerContent = sliderTrack;
            if (controls === true) {
                sliderInnerContent += sliderControls;
            }
            if (bullets === true) {
                sliderInnerContent += '<div class="slider__bullets glide__bullets" data-glide-el="controls[nav]">' + sliderBullets + '</div>';
            }
            sliderEl.innerHTML = sliderInnerContent;

            var sliderTrackEl = sliderEl.querySelector('.glide__track');
            sliderTrackEl.appendChild(sliderContainer);

            new Glide('.ce-hero_slider .glide', {
                type: 'carousel',
                autoplay: 4000,
                gap: 0,
                hoverpause: true
            }).mount();
        }
    },

    HeaderShrink: {
        init: function () {
            window.addEventListener('scroll', function(e) {
                const distanceY = window.pageYOffset || document.documentElement.scrollTop;
                const shrinkOn = 80;
                const pageHeader = document.querySelector('.page-header');

                if (distanceY > shrinkOn) {
                    pageHeader.classList.add('compact');
                } else {
                    pageHeader.classList.remove('compact');
                }
            })
        }
    },

    Video: {
        userConsentAvailable: false,
        init: function () {
            document.querySelectorAll('.video-keep-data-privacy[data-video-type="youtube"]').forEach(function (videoItem) {
                console.log(videoItem);
                //videoItem.addEventListener('click', FE.Video.checkVideoLoading);
                videoItem.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                    FE.Video.loadVideo(e.currentTarget);
                });
            });
            if (sessionStorage.getItem('youTubeConsent') === '1') {
                this.userConsentAvailable = true;
            }
        },
        loadVideo: function (videoItem) {
            const videoId = videoItem.dataset.videoId;
            const videoArea = videoItem.parentElement;

            FE.Video.addUserConsent(videoArea, videoId);

            //console.log(videoArea);

            // check potential permission via consent manager or any other persistent data such as session storage or cookie
            if ( FE.Video.userConsentAvailable) {
                videoArea.innerHTML = FE.Video.getYouTubeEmbedCode(videoId);
            } else {
                videoItem.nextElementSibling.classList.add('show');
            }

        },
        embedVideo: function (videoArea, videoId) {
            videoArea.innerHTML = FE.Video.getYouTubeEmbedCode(videoId);
        },
        getVimeoEmbedCode: function (videoId) {
            return '<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/' + videoId + '?h=96a48e54c0&byline=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>';
        },
        getYouTubeEmbedCode: function (videoId) {
            return '<iframe width="100%" height="315" src="https://www.youtube-nocookie.com/embed/' + videoId + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
        },
        addUserConsent: function (videoArea, videoId) {
            const videoConsentHtml = `An dieser Stelle laden wir ein externes Video von YouTube.<br>
                                        Mir ist bewusst, dass dabei Daten mit den YouTube Servern ausgetauscht werden.<br>
                                        Weitere Informationen zu den <a href="https://policies.google.com/technologies/cookies?hl=de" target="_blank" rel="noopener">YouTube Datenschutzbedingungen</a>.
                                        <div class="btn-group"><button class="btn-video-confirm">Geht klar</button><button class="btn-video-deny">möchte ich nicht</button>`;

            const videoConsent = document.createElement('div');
            videoConsent.classList.add('external-video-consent');
            videoConsent.innerHTML = `<div class="external-video-consent-inner">${videoConsentHtml}</div>`;
            videoArea.append(videoConsent);
            videoArea.querySelector('.btn-video-confirm').addEventListener('click', function (e) {
                FE.Video.embedVideo(videoArea, videoId);
                sessionStorage.setItem('youTubeConsent', '1');
            });
            videoArea.querySelector('.btn-video-deny').addEventListener('click', function (e) {
                e.target.closest('.external-video-consent').classList.remove('show');
            });
        }
    }

};

// init custom functions
window.addEventListener("DOMContentLoaded", function () {

    FE.MobileMenu.init();
    FE.HeaderShrink.init();

    if ( document.querySelector('.ce-video') ) {
        FE.Video.init();
    }

    if ( document.querySelector('.ce-text_image_accordion--item') ) {
        FE.Accordion.init();
    }

    if ( document.querySelectorAll('.lightbox').length ) {
        FE.Modal.init();
    }

    if ( document.querySelectorAll('.ce-hero_slider--slides figure').length > 1 ) {
        FE.HeroSlider.init();
    }
});